import React from 'react';

import classNames from 'classnames/bind';
import style from './Footer.scss';
const ctx = classNames.bind(style);

import { withRouter } from 'react-router';

@withRouter
class Footer extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const currentYear = new Date().getFullYear();
    return (
      <div className={ctx('footer')}>
        © {currentYear} Спецпроект Коммерсант.ru | Галс: Интеллектуальная
        Недвижимость. Все права защищены.
        <br />
        ИСКРА-ПАРК: Проектная декларация на{' '}
        <a href="http://www.iskra-park.ru" target="_blank">
          www.iskra-park.ru
        </a>
        . Застройщик ООО «Искра-Парк».
        <br />
        МАТЧ ПОИНТ: Проектная декларация на{' '}
        <a href="https://www.matchpointhouse.ru" target="_blank">
          www.matchpointhouse.ru
        </a>
        . Застройщик ООО «Волей Гранд».
        <br />
        ДОСТОЯНИЕ: Проектная декларация на{' '}
        <a href="https://www.dostoyanie-hals.ru" target="_blank">
          www.dostoyanie-hals.ru
        </a>
        . Застройщик ЗАО «Кунцево-Инвест».
        <br />
        Разработка: Python Creative Group ©
      </div>
    );
  }
}

export default Footer;
